/**
 * 🤖 AUTO-GENERATED FILE - DO NOT EDIT!
 *
 * This file is automatically generated by vite-plugins/markdown-routes.ts
 * Source: content/blog/thoughtful/my-first-thoughts-in-nyc.md
 *
 * ⚠️ Any manual changes will be overwritten on next build.
 *
 * To modify this blog post:
 * 1. Edit the source markdown file: content/blog/thoughtful/my-first-thoughts-in-nyc.md
 * 2. Run the build process to regenerate this file
 */

import { createFileRoute } from '@tanstack/react-router';
import { ArticleLayout } from '@/components/ArticleLayout';
import { createArticleMeta } from '@/lib/meta';
import Content from '@/content/my-first-thoughts-in-nyc.mdx';

const metadata = {
  slug: "my-first-thoughts-in-nyc",
  title: "My First Thoughts in NYC",
  author: "Christian Battaglia",
  description: "From an August road trip recon mission to officially moving in January 2018 — my first impressions of the city, the subway system, the neighborhoods, and the overwhelming question: am I a New Yorker now?\n",
  authorImage: "/assets-cdbattaglia/media/images/chris_profile.svg",
  headerImage: "/assets-cdbattaglia/media/blog-posts/frank-kohntopp-130291.webp",
  date: "2018-01-18T00:00:00.000Z",
  
  readTime: "5 min read",
  tags: ["NYC","New York","moving","travel","InRhythm","subway","neighborhoods","new beginnings"],
};

export const Route = createFileRoute('/blog/posts/my-first-thoughts-in-nyc')({
  component: ArticlePage,
  head: () => createArticleMeta({
    title: `${metadata.title}${metadata.author ? ` - ${metadata.author}` : ''}`,
    description: metadata.description || '',
    path: '/blog/posts/my-first-thoughts-in-nyc',
    image: '/og/blog/my-first-thoughts-in-nyc.png',
    imageAlt: metadata.title,
    datePublished: metadata.date,
    dateModified: undefined,
    authorName: metadata.author,
    tags: metadata.tags,
    readTime: metadata.readTime,
    section: 'Blog',
  }),
});

function ArticlePage() {
  return (
    <ArticleLayout {...metadata}>
      <Content />
    </ArticleLayout>
  );
}
